import packingRequest from '../request/packing'

const apiRequest = packingRequest()

export const getListProductionMethods = async (payload) => {
    const {data} = await apiRequest({
        url: '/order/production-method',
        method: 'GET',
        params: payload,
    })

    return data
}

export const importProductionMethods = async (payload) => {
    const {data} = await apiRequest({
        url: '/order/import-production-method',
        method: 'POST',
        data: payload,
    })

    return data
}

export const createProductionMethods = async (payload) => {
    const {data} = await apiRequest({
        url: `/order/production-method/create`,
        method: 'POST',
        data: payload,
    })

    return data
}

export const updateProductionMethods = async (id, payload) => {
    const {data} = await apiRequest({
        url: `/order/production-method/${id}`,
        method: 'PUT',
        data: payload,
    })

    return data
}